import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=7700ad5c&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=babel&"
export * from "./productList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700ad5c",
  null
  
)

export default component.exports